import { Button, FormGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import appHistory from "../../../app/appHistory";
import Icon from "../../../components/icon/Icon";
import { RouterPaths } from "../../../app/appConstants";
import { payoutCancelAction } from '../withdrawalReducer';

function WithdrawCancel(props) {
    const { getLangPath } = useLangContext();
    const { uuid } = props;
    const dispatch = useDispatch();

    const submitHandler = useCallback(() => {
        dispatch(payoutCancelAction({
            uuid, callback: () => {
                appHistory.push(RouterPaths.main);
            }
        }));
    }, [dispatch, uuid]);

    const cancelHandler = useCallback(() => {
        appHistory.goBack();
    }, []);

    if (!uuid) {
        return null;
    }

    return <>
        <div className="text-center mb-3"
             style={{ color: 'var(--color-negative)' }}>
            <Icon name={'IcAttention'} size={40}/>
        </div>
        <h3 className={'text-center'}>{getLangPath('lite_version.cancel_withdrawal_modal.title')}</h3>
        <div className={'f16 my-3 text-center'}>{getLangPath('lite_version.cancel_withdrawal_modal.description')}</div>
        <FormGroup className={'mt-3'}>
            <Button variant={'primary'}
                    className={'mb-2 w-100'}
                    onClick={submitHandler}>{getLangPath('lite_version.cancel_withdrawal_modal.submit')}</Button>
            <Button variant={'secondary'}
                    className={'w-100 text-secondary'}
                    onClick={cancelHandler}>{getLangPath('lite_version.cancel_withdrawal_modal.cancel')}</Button>
        </FormGroup>
    </>
}

export default WithdrawCancel;
